import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.texts[0]), 1),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.texts[1]), 513), [
            [_vShow, _ctx.isReadMore && _ctx.texts.length > 1]
          ])
        ]),
        _: 1
      })
    ]),
    (_ctx.text && _ctx.text.length > _ctx.max)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.isReadMore)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button button--text-more",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.triggerReadMore(true)))
              }, _toDisplayString(_ctx.moreText), 1))
            : _createCommentVNode("", true),
          (_ctx.isReadMore)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button button--text-more is-active",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerReadMore(false)))
              }, _toDisplayString(_ctx.lessText), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isTranslateEnabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.showTranslateButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "button button--translate",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.translate()))
              }, _toDisplayString(_ctx.languageId == 'sk' ? 'Translate' : 'Translated by Google'), 1))
            : _createCommentVNode("", true),
          (_ctx.showOriginalTextButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "button button--translate-original",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showOriginalText()))
              }, "Show original"))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}